<template>
  <div class="animated fadeIn page-shell">
    <HeaderPadrao class="mb-2" icon="fa fa-truck" titulo="ORDEM DE ENTREGA">
      <template #subtitulo>
        <i class="fa fa-tag mr-1 text-info"></i>
        Id: <strong class="text-white">{{ registro.ID > 0 ? registro.ID : 'Novo' }}</strong>
        <span class="mx-2">|</span>
        <i class="fa fa-info-circle mr-1 text-info"></i>
        Situacao: <strong class="text-white">{{ traduzStatus(registro.STATUS) }}</strong>
      </template>

      <template #acoes>
        <b-button v-if="exibirBotaoLiberar" variant="link" class="btn-glass btn-glass-success" @click.stop.prevent="liberar()">
          <i class="fa fa-check mr-1"></i> Liberar
        </b-button>

        <b-button v-if="exibirBotaoGravar" variant="link" class="btn-glass btn-glass-primary" @click.stop.prevent="salvar()">
          <i class="fa fa-save mr-1"></i> Gravar
        </b-button>

        <b-button v-if="exibirBotaoFinalizarEntrega" variant="link" class="btn-glass btn-glass-success" @click.stop.prevent="finalizarEntrega()">
          <i class="fa fa-flag-checkered mr-1"></i> Finalizar Entrega
        </b-button>

        <b-button v-if="exibirBotaoReabrir" variant="link" class="btn-glass btn-glass-warning" @click.stop.prevent="reabrir()">
          <i class="fa fa-unlock mr-1"></i> Reabrir
        </b-button>

        <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm" @click.stop.prevent="voltar()">
          <i class="fa fa-arrow-left mr-1"></i> Voltar
        </b-button>
      </template>
    </HeaderPadrao>

    <div class="page-main px-3">
      <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
        <div class="card-header bg-white border-bottom-0 py-3">
          <h5 class="mb-0 text-primary font-weight-bold">
            <i class="fa fa-list-alt mr-2"></i>Dados da Entrega
          </h5>
        </div>
        <b-card-body class="pt-0">
          <b-row>
            <b-col sm="2">
              <b-form-group label="Codigo ID" label-class="modal-label-premium">
                <b-form-input type="text" :disabled="true" class="rounded-pill bg-light border-0 shadow-xs" placeholder="Codigo Automatico" v-model="registro.ID" />
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group label="Data" label-class="modal-label-premium">
                <b-form-input type="date" :disabled="desabilitarQuandoFechado" class="rounded-pill shadow-xs" v-model="registro.DATA" :state="registro.DATA != null" />
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group label="Situacao" label-class="modal-label-premium">
                <b-form-input type="text" :disabled="true" class="rounded-pill bg-light border-0 shadow-xs" :value="traduzStatus(registro.STATUS)" />
              </b-form-group>
            </b-col>
            <b-col sm="5">
              <b-form-group label="Observacao" label-class="modal-label-premium">
                <b-form-input type="text" :disabled="desabilitarQuandoFechado" class="rounded-pill shadow-xs" v-model="registro.OBSERVACAO" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col sm="5">
              <b-form-group label-class="modal-label-premium">
                <template #label>
                  Motorista <span class="text-danger">*</span>
                </template>
                <funcionario-dropdown
                  v-model="registro.COD_MOTORISTA"
                  :disabled="desabilitarQuandoFechado"
                  input-class="rounded-pill shadow-xs"
                  :placeholder="'Pesquise pelo motorista...'"
                />
              </b-form-group>
            </b-col>
            <b-col sm="5">
              <b-form-group label-class="modal-label-premium">
                <template #label>
                  Veiculo <span class="text-danger">*</span>
                </template>
                <veiculo-dropdown
                  v-model="registro.VEICULO_ID"
                  :disabled="desabilitarQuandoFechado"
                  input-class="rounded-pill shadow-xs"
                  :placeholder="'Pesquise pelo veiculo...'"
                />
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group label="Placa" label-class="modal-label-premium">
                <b-form-input
                  type="text"
                  :disabled="desabilitarQuandoFechado"
                  class="rounded-pill shadow-xs"
                  v-model="registro.PLACA"
                  placeholder="Placa"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <!-- Painel de Capacidade de Carga Premium -->
      <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg overflow-hidden load-capacity-card" v-if="registro.VEICULO_ID">
        <b-card-body class="p-4">
          <b-row class="align-items-center">
            <b-col md="4" class="text-center text-md-left mb-3 mb-md-0">
              <div class="d-flex align-items-center justify-content-center justify-content-md-start">
                <div class="load-icon-box mr-3" :class="loadThemeClass">
                  <i class="fa fa-truck fa-2x"></i>
                </div>
                <div>
                  <span class="text-muted small uppercase font-weight-bold tracking-wider d-block">Capacidade do Veículo</span>
                  <h4 class="mb-0 text-dark font-weight-bold">{{ formatarQuant(capacidadeVeiculo) }} Kg</h4>
                  <small class="text-muted" v-if="registro.PLACA">Placa: <strong>{{ registro.PLACA }}</strong></small>
                </div>
              </div>
            </b-col>
            <b-col md="4" class="text-center mb-3 mb-md-0 border-md-left border-md-right">
              <div>
                <span class="text-muted small uppercase font-weight-bold tracking-wider d-block">Peso Carregado</span>
                <h4 class="mb-0 font-weight-bold" :class="loadTextClass">{{ formatarQuant(pesoCarregado) }} Kg</h4>
                <small class="text-muted">De {{ vendasDaOrdem.length }} pedido(s) listado(s)</small>
              </div>
            </b-col>
            <b-col md="4" class="text-center text-md-left pl-md-4">
              <div class="d-flex flex-column justify-content-center h-100">
                <div class="d-flex justify-content-between mb-1">
                  <span class="font-weight-bold small text-muted">Aproveitamento</span>
                  <span class="font-weight-bold small" :class="loadTextClass">{{ percentualCarregado.toFixed(1) }}%</span>
                </div>
                <!-- Premium Progress Bar -->
                <div class="custom-progress-container mb-2">
                  <div class="custom-progress-bar-fill" :style="{ width: Math.min(percentualCarregado, 100) + '%' }" :class="loadBgClass"></div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-muted small">
                    <span v-if="excessoCarga > 0" class="text-danger font-weight-bold">
                      <i class="fa fa-exclamation-triangle mr-1"></i> Excesso: <strong>{{ formatarQuant(excessoCarga) }} Kg</strong>
                    </span>
                    <span v-else>
                      Disponível: <strong>{{ formatarQuant(saldoCapacidade) }} Kg</strong>
                    </span>
                  </span>
                  <b-badge :variant="loadBadgeVariant" pill class="px-3 py-1 font-weight-bold tracking-wide">
                    {{ loadStatusText }}
                  </b-badge>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-row>
        <b-col sm="6">
          <b-card no-body class="border-0 shadow-sm rounded-lg h-100">
            <div class="card-header bg-white border-bottom-0 py-3 d-flex justify-content-between align-items-center">
              <h5 class="mb-0 text-primary font-weight-bold">
                <i class="fa fa-clock-o mr-2"></i>Vendas Finalizadas
              </h5>
              <b-button size="sm" variant="outline-primary" class="rounded-pill" @click="atualizarListas" :disabled="isLoading">
                <i class="fa fa-refresh" :class="{'fa-spin': isLoading}"></i>
              </b-button>
            </div>
            <b-card-body class="p-0">
              <b-table
                class="table table-sm"
                show-empty
                empty-text="Nenhuma venda disponivel"
                small
                responsive
                sticky-header
                hover
                :busy.sync="isLoading"
                :items="vendasDisponiveis"
                :fields="fieldsDisponiveis"
              >
                <template #cell(DT_SAIDA)="row">
                  {{ formatarData(row.item.DT_SAIDA) }}
                </template>
                <template #cell(QUANT_TOTAL)="row">
                  {{ formatarQuant(row.item.QUANT_TOTAL) }}
                </template>
                <template #cell(BAIRRO)="data">
                  <b-badge v-if="data.value" variant="light" class="border text-secondary">{{ data.value }}</b-badge>
                  <span v-else class="text-muted">—</span>
                </template>
                <template #cell(actions)="row">
                  <b-button v-if="!desabilitarQuandoFechado" size="sm" variant="success" title="Adicionar" @click.stop.prevent="addVenda(row.item)" v-b-tooltip.hover.left>
                    <i class="fa fa-arrow-right"></i>
                  </b-button>
                </template>
              </b-table>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col sm="6">
          <b-card no-body class="border-0 shadow-sm rounded-lg h-100">
            <div class="card-header bg-white border-bottom-0 py-3">
              <h5 class="mb-0 text-primary font-weight-bold">
                <i class="fa fa-list mr-2"></i>Nessa Entrega
              </h5>
            </div>
            <b-card-body class="p-0">
              <b-table
                class="table table-sm"
                show-empty
                empty-text="Nenhuma venda nessa Ordem"
                small
                responsive
                sticky-header
                hover
                :busy.sync="isLoading"
                :items="vendasDaOrdem"
                :fields="fieldsOrdem"
              >
                <template #cell(DT_SAIDA)="row">
                  {{ formatarData(row.item.DT_SAIDA) }}
                </template>
                <template #cell(QUANT_TOTAL)="row">
                  {{ formatarQuant(row.item.QUANT_TOTAL) }}
                </template>
                <template #cell(BAIRRO)="data">
                  <b-badge v-if="data.value" variant="light" class="border text-secondary">{{ data.value }}</b-badge>
                  <span v-else class="text-muted">—</span>
                </template>
                <template #cell(ENTREGA)="row">
                  <b-badge pill :variant="variantEntregaVenda(row.item)">
                    {{ statusEntregaVenda(row.item) }}
                  </b-badge>
                  <div v-if="row.item.OBS_RETORNO" class="small text-muted mt-1">
                    {{ row.item.OBS_RETORNO }}
                  </div>
                </template>
                <template #cell(actions)="row">
                  <b-button v-if="!desabilitarQuandoFechado" size="sm" variant="danger" title="Remover" @click.stop.prevent="delVenda(row.item)" v-b-tooltip.hover.left>
                    <i class="fa fa-arrow-left"></i>
                  </b-button>
                  <template v-if="entregaLiberada">
                    <b-button
                      size="sm"
                      variant="success"
                      title="Confirmar Entrega"
                      class="mr-1"
                      :disabled="!podeConfirmarEntregaVenda(row.item)"
                      @click.stop.prevent="confirmarEntregaVenda(row.item)"
                      v-b-tooltip.hover.left
                    >
                      <i class="fa fa-check"></i>
                    </b-button>
                    <b-button
                      size="sm"
                      variant="warning"
                      title="Registrar Ocorrencia"
                      :disabled="isVendaEntregue(row.item)"
                      @click.stop.prevent="abrirOcorrenciaEntrega(row.item)"
                      v-b-tooltip.hover.left
                    >
                      <i class="fa fa-exclamation-circle"></i>
                    </b-button>
                  </template>
                </template>
              </b-table>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-3" v-if="registro.ID">
        <b-col>
          <b-card no-body class="border-0 shadow-sm rounded-lg mt-3">
            <div class="card-header bg-white border-bottom-0 py-3">
              <h5 class="mb-0 text-primary font-weight-bold">
                <i class="fa fa-calculator mr-2"></i>Totalizados
              </h5>
            </div>
            <b-card-body class="pt-0">
              <b-row class="mb-3">
                <b-col>
                  <b-form-group label="Totalizar Por:" label-cols="2">
                    <b-form-radio-group v-model="totalizados.agrupamento" buttons button-variant="outline-primary" size="sm">
                      <b-form-radio value="produto">Por Produto</b-form-radio>
                      <b-form-radio value="bairro">Por Bairro</b-form-radio>
                      <b-form-radio value="municipio">Por Municipio</b-form-radio>
                      <b-form-radio value="cliente">Por Cliente</b-form-radio>
                      <b-form-radio value="vendedor">Por Vendedor</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col cols="auto">
                  <b-button variant="primary" size="sm" @click="imprimirTotalizados" :disabled="!totalizadosAgrupados.length">
                    <i class="fa fa-print"></i> Imprimir
                  </b-button>
                </b-col>
              </b-row>

              <b-table
                :items="totalizadosAgrupados"
                :fields="totalizadosFields"
                striped
                small
                hover
                responsive
                show-empty
                empty-text="Nenhum dado disponivel"
                :foot-clone="totalizadosAgrupados.length > 0"
                @row-clicked="toggleDetalhesTotalizados"
              >
                <template #cell(DETALHE)="row" v-if="totalizados.agrupamento !== 'produto'">
                  <i
                    :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                    @click.stop="toggleDetalhesTotalizados(row)"
                    style="cursor: pointer"
                  ></i>
                </template>
                <template #cell(QUANT)="data">
                  {{ formatarQuant(data.value) }}
                </template>
                <template #foot()="">
                  <span></span>
                </template>
                <template #foot(AGRUPAMENTO)="">
                  <strong>TOTAL GERAL</strong>
                </template>
                <template #foot(QUANT)="">
                  <strong>{{ formatarQuant(totalGeral.QUANT) }}</strong>
                </template>
                <template #foot(PECAS)="">
                  <strong>{{ totalGeral.PECAS }}</strong>
                </template>
                <template #foot(PECAS_PEDIDO)="">
                  <strong>{{ totalGeral.PECAS_PEDIDO }}</strong>
                </template>
                <template #row-details="row" v-if="totalizados.agrupamento !== 'produto'">
                  <b-table
                    head-variant="dark"
                    :hover="false"
                    table-variant="light"
                    :items="row.item.detalhes"
                    :fields="tabelaProdutosCliente.fields"
                    small
                  />
                </template>
              </b-table>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal
      id="modal-ocorrencia-entrega"
      ref="modal-ocorrencia-entrega"
      title="Registrar Ocorrencia"
      centered
      hide-footer
    >
      <div v-if="ocorrenciaEntrega.venda">
        <div class="mb-3">
          <strong>{{ ocorrenciaEntrega.venda.NOME_CLIENTE }}</strong>
          <div class="small text-muted">Pedido {{ ocorrenciaEntrega.venda.N_VENDA || ocorrenciaEntrega.venda.SEQUENCIA }}</div>
        </div>

        <b-form-group label="Tipo" label-class="modal-label-premium">
          <b-form-select v-model="ocorrenciaEntrega.tipo" :options="tiposOcorrenciaEntrega" />
        </b-form-group>

        <b-form-group label="Observacao" label-class="modal-label-premium">
          <b-form-textarea
            v-model="ocorrenciaEntrega.observacao"
            rows="4"
            maxlength="450"
            placeholder="Descreva o motivo da nao entrega ou a ocorrencia registrada..."
          />
        </b-form-group>

        <div class="d-flex justify-content-end mt-3">
          <b-button variant="light" class="mr-2" @click="$bvModal.hide('modal-ocorrencia-entrega')">Cancelar</b-button>
          <b-button variant="warning" :disabled="!ocorrenciaEntrega.tipo || isLoading" @click="salvarOcorrenciaEntrega">
            <i class="fa fa-save mr-1"></i> Gravar Ocorrencia
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import moment from 'moment'
import Tools from '@/tools/tools.js'
import FuncionarioDropdown from '../../componentes/dropdown/FuncionarioDropdown.vue'
import VeiculoDropdown from '../../componentes/dropdown/VeiculoDropdown.vue'
import { imprimirRelatorioEntrega } from './OrdemEntregaRelatorio'

export default {
  name: 'OrdemEntregaCadastro',
  components: {
    HeaderPadrao,
    FuncionarioDropdown,
    VeiculoDropdown
  },
  data () {
    return {
      isLoading: false,
      veiculoSelecionado: null,
      registro: {
        ID: null,
        DATA: moment().format('YYYY-MM-DD'),
        STATUS: '1',
        COD_MOTORISTA: null,
        VEICULO_ID: null,
        OBSERVACAO: null,
        PLACA: null
      },
      vendasDisponiveis: [],
      vendasDaOrdem: [],
      fieldsDisponiveis: [
        { key: 'N_VENDA', label: 'Venda', sortable: true },
        { key: 'NOME_CLIENTE', label: 'Cliente', sortable: true },
        { key: 'BAIRRO', label: 'Bairro', sortable: true },
        { key: 'DT_SAIDA', label: 'Fatura', sortable: true },
        { key: 'QUANT_TOTAL', label: 'Peso', sortable: true, class: 'text-right' },
        { key: 'actions', label: 'Acoes', class: 'text-right', thStyle: { width: '70px' } }
      ],
      fieldsOrdem: [
        { key: 'actions', label: 'Acoes', class: 'text-right', thStyle: { width: '120px' } },
        { key: 'N_VENDA', label: 'Venda', sortable: true },
        { key: 'NOME_CLIENTE', label: 'Cliente', sortable: true },
        { key: 'BAIRRO', label: 'Bairro', sortable: true },
        { key: 'DT_SAIDA', label: 'Fatura', sortable: true },
        { key: 'QUANT_TOTAL', label: 'Peso', sortable: true, class: 'text-right' },
        { key: 'ENTREGA', label: 'Entrega', class: 'text-center' }
      ],
      ocorrenciaEntrega: {
        venda: null,
        tipo: null,
        observacao: ''
      },
      tiposOcorrenciaEntrega: [
        { value: null, text: '-- Selecione --' },
        { value: 'PARCIAL', text: 'Entrega parcial' },
        { value: 'DEVOLVIDO', text: 'Devolvido' },
        { value: 'RECUSADO', text: 'Recusado pelo cliente' },
        { value: 'AUSENTE', text: 'Cliente ausente' },
        { value: 'OUTROS', text: 'Outros' }
      ],
      totalizados: {
        agrupamento: 'bairro',
        dados: [],
        fields: [
          {
            key: 'DETALHE',
            label: '',
            thStyle: { width: '3%' },
            thClass: 'text-center',
            class: 'text-center'
          },
          {
            key: 'CODIGO',
            label: 'Codigo',
            sortable: true,
            thStyle: { width: '10%' },
            class: 'text-right'
          },
          {
            key: 'AGRUPAMENTO',
            label: 'Descricao',
            sortable: true,
            thStyle: { width: '27%' }
          },
          {
            key: 'QUANT',
            label: 'Peso (Kg)',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '20%' }
          },
          {
            key: 'PECAS',
            label: 'Pecas Conferidas',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '20%' }
          },
          {
            key: 'PECAS_PEDIDO',
            label: 'Pecas Pedido',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '20%' }
          }
        ]
      },
      tabelaProdutosCliente: {
        fields: [
          { key: 'COD_PRO', label: 'Cod. Produto', thStyle: { width: '15%' }, class: 'text-right' },
          { key: 'NOME_PRODUTO', label: 'Produto', thStyle: { width: '40%' } },
          {
            key: 'QUANT',
            label: 'Peso (Kg)',
            class: 'text-right',
            thStyle: { width: '15%' },
            formatter: (value) => this.formatarQuant(value)
          },
          { key: 'PECAS', label: 'Pecas Conferidas', class: 'text-right', thStyle: { width: '15%' } },
          { key: 'PECAS_PEDIDO', label: 'Pecas Pedido', class: 'text-right', thStyle: { width: '15%' } }
        ]
      }
    }
  },
  computed: {
    desabilitarQuandoFechado () {
      return this.registro.STATUS !== '1'
    },
    exibirBotaoGravar () {
      return this.registro.STATUS === '1'
    },
    exibirBotaoLiberar () {
      return this.registro.ID && this.registro.STATUS === '1' && this.registro.COD_MOTORISTA && this.registro.VEICULO_ID
    },
    exibirBotaoReabrir () {
      return this.registro.ID && this.registro.STATUS === '2'
    },
    entregaLiberada () {
      return String(this.registro.STATUS || '').trim() === '2'
    },
    exibirBotaoFinalizarEntrega () {
      return this.registro.ID && this.entregaLiberada
    },
    totalizadosFields () {
      // Para agrupamento por bairro não há código numérico separado — oculta a coluna CODIGO
      if (this.totalizados.agrupamento === 'bairro') {
        return this.totalizados.fields.filter(f => f.key !== 'CODIGO')
      }
      return this.totalizados.fields
    },
    totalizadosAgrupados () {
      if (!this.totalizados.dados || !this.totalizados.dados.length) {
        return []
      }

      const mapa = {}
      let campoCodigo = null
      let campoNome = null

      switch (this.totalizados.agrupamento) {
        case 'produto':
          campoCodigo = 'COD_PRO'
          campoNome = 'NOME_PRODUTO'
          break
        case 'bairro':
          campoCodigo = 'BAIRRO'
          campoNome = 'BAIRRO'
          break
        case 'municipio':
          campoCodigo = 'MUNICIPIO_ID'
          campoNome = 'NOME_MUNICIPIO'
          break
        case 'cliente':
          campoCodigo = 'COD_CLI'
          campoNome = 'NOME_CLIENTE'
          break
        case 'vendedor':
          campoCodigo = 'COD_VENDEDOR'
          campoNome = 'NOME_VENDEDOR'
          break
        default:
          campoNome = 'NOME_PRODUTO'
          campoCodigo = 'COD_PRO'
      }

      this.totalizados.dados.forEach(item => {
        const codigo = campoCodigo ? (item[campoCodigo] || '') : ''
        const nome = item[campoNome] || '-- Nao informado --'
        const chave = `${codigo}|${nome}`

        if (!mapa[chave]) {
          mapa[chave] = { codigo, nome, QUANT: 0, PECAS: 0, PECAS_PEDIDO: 0 }
        }

        mapa[chave].QUANT += Number(item.QUANT || 0)
        mapa[chave].PECAS += Number(item.PECAS || 0)
        mapa[chave].PECAS_PEDIDO += Number(item.PECAS_PEDIDO || 0)
      })

      return Object.keys(mapa).map(key => ({
        CODIGO: mapa[key].codigo,
        AGRUPAMENTO: mapa[key].nome,
        QUANT: mapa[key].QUANT,
        PECAS: mapa[key].PECAS,
        PECAS_PEDIDO: mapa[key].PECAS_PEDIDO
      }))
    },
    totalGeral () {
      if (!this.totalizadosAgrupados || !this.totalizadosAgrupados.length) {
        return { QUANT: 0, PECAS: 0, PECAS_PEDIDO: 0 }
      }

      return this.totalizadosAgrupados.reduce((acc, item) => {
        acc.QUANT += Number(item.QUANT || 0)
        acc.PECAS += Number(item.PECAS || 0)
        acc.PECAS_PEDIDO += Number(item.PECAS_PEDIDO || 0)
        return acc
      }, { QUANT: 0, PECAS: 0, PECAS_PEDIDO: 0 })
    },
    capacidadeVeiculo () {
      return this.veiculoSelecionado ? Number(this.veiculoSelecionado.CAPACIDADE || 0) : 0
    },
    pesoCarregado () {
      return this.vendasDaOrdem.reduce((total, item) => total + Number(item.QUANT_TOTAL || 0), 0)
    },
    percentualCarregado () {
      if (this.capacidadeVeiculo <= 0) return 0
      return (this.pesoCarregado / this.capacidadeVeiculo) * 100
    },
    saldoCapacidade () {
      return Math.max(0, this.capacidadeVeiculo - this.pesoCarregado)
    },
    excessoCarga () {
      return Math.max(0, this.pesoCarregado - this.capacidadeVeiculo)
    },
    loadThemeClass () {
      if (this.percentualCarregado > 100) return 'red-theme'
      if (this.percentualCarregado >= 80) return 'orange-theme'
      return 'green-theme'
    },
    loadTextClass () {
      if (this.percentualCarregado > 100) return 'text-danger'
      if (this.percentualCarregado >= 80) return 'text-warning'
      return 'text-success'
    },
    loadBgClass () {
      if (this.percentualCarregado > 100) return 'bg-gradient-danger'
      if (this.percentualCarregado >= 80) return 'bg-gradient-warning'
      return 'bg-gradient-success'
    },
    loadBadgeVariant () {
      if (this.percentualCarregado > 100) return 'danger'
      if (this.percentualCarregado >= 80) return 'warning'
      return 'success'
    },
    loadStatusText () {
      if (this.percentualCarregado > 100) return 'SOBRECARREGADO'
      if (this.percentualCarregado >= 80) return 'PROXIMO AO LIMITE'
      return 'DENTRO DO LIMITE'
    }
  },
  watch: {
    'registro.VEICULO_ID': {
      async handler (newVal) {
        if (newVal) {
          await this.obterDadosVeiculo(newVal)
        } else {
          this.veiculoSelecionado = null
        }
      },
      immediate: true
    }
  },
  async mounted () {
    await this.carregarRegistro()
    await this.atualizarListas()
  },
  methods: {
    async obterDadosVeiculo (veiculoId) {
      try {
        const result = await this.$http.get(`/api/protected/veiculo/getById/${veiculoId}`)
        if (result.data && result.data.length > 0) {
          this.veiculoSelecionado = result.data[0]
          if (!this.registro.PLACA && result.data[0].PLACA) {
            this.registro.PLACA = result.data[0].PLACA.trim()
          }
        }
      } catch (err) {
        console.error('Erro ao obter dados do veiculo:', err)
      }
    },
    async carregarRegistro () {
      const id = this.$route.params.id
      if (!id) return

      this.isLoading = true
      try {
        const result = await this.$http.get(`/api/protected/ordementrega/getById/${id}`)
        if (result.data && result.data.length > 0) {
          this.registro = {
            ...this.registro,
            ...result.data[0],
            DATA: result.data[0].DATA ? moment(String(result.data[0].DATA)).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
          }
        }
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.isLoading = false
      }
    },
    async atualizarListas () {
      this.isLoading = true
      try {
        const disponiveis = await this.$http.get('/api/protected/ordementrega/getVendasDisponiveis')
        this.vendasDisponiveis = disponiveis.data || []

        if (this.registro.ID) {
          const vinculadas = await this.$http.get(`/api/protected/ordementrega/getVendasDaOrdem/${this.registro.ID}`)
          this.vendasDaOrdem = vinculadas.data || []
          await this.buscarDetalhesVendasDaOrdem()
        } else {
          this.vendasDaOrdem = []
          this.totalizados.dados = []
        }
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.isLoading = false
      }
    },
    async buscarDetalhesVendasDaOrdem () {
      if (!this.registro.ID) {
        this.totalizados.dados = []
        return
      }

      try {
        const result = await this.$http.get(`/api/protected/ordementrega/getDetalhesVendasDaOrdem/${this.registro.ID}`)
        this.totalizados.dados = result.data || []
      } catch (err) {
        this.totalizados.dados = []
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      }
    },
    async salvar () {
      if (!this.registro.COD_MOTORISTA) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'O campo Motorista é obrigatório.')
        return
      }
      if (!this.registro.VEICULO_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'O campo Veículo/Caminhão é obrigatório.')
        return
      }

      this.isLoading = true
      try {
        const result = await this.$http.post('/api/protected/ordementrega/post', {
          ordemEntrega: this.registro,
          usuario: window.localStorage.getItem('login')
        })
        const row = Array.isArray(result.data) ? result.data[0] : result.data
        if (row && row.ID) {
          this.registro.ID = row.ID
          this.$store.commit('ordemEntrega/SET_REGISTRO_SELECIONADO_ID', row.ID)
        }
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Ordem de Entrega gravada com sucesso!')
        if (this.registro.ID && !this.$route.params.id) {
          this.$router.replace(`/expedicao/ordementrega/edit/${this.registro.ID}`)
        }
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.isLoading = false
      }
    },
    async addVenda (venda) {
      if (!this.registro.COD_MOTORISTA) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Selecione um Motorista antes de adicionar vendas.')
        return
      }
      if (!this.registro.VEICULO_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Selecione um Veículo antes de adicionar vendas.')
        return
      }

      this.isLoading = true
      try {
        const result = await this.$http.post('/api/protected/ordementrega/addVenda', {
          ordemEntrega: this.registro,
          vendaId: venda.SEQUENCIA,
          usuario: window.localStorage.getItem('login')
        })
        const row = Array.isArray(result.data) ? result.data[0] : result.data
        if (row && row.ID) {
          this.registro.ID = row.ID
          this.$store.commit('ordemEntrega/SET_REGISTRO_SELECIONADO_ID', row.ID)
          if (!this.$route.params.id) {
            this.$router.replace(`/expedicao/ordementrega/edit/${row.ID}`)
          }
        }
        await this.atualizarListas()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.isLoading = false
      }
    },
    async delVenda (venda) {
      const confirm = await this.$bvModal.msgBoxConfirm('Deseja remover esta venda da Ordem de Entrega?', {
        title: 'Remover Venda',
        okTitle: 'SIM',
        cancelTitle: 'NAO',
        okVariant: 'danger',
        centered: true
      })
      if (!confirm) return

      this.isLoading = true
      try {
        await this.$http.post('/api/protected/ordementrega/delVenda', {
          ordemEntregaId: this.registro.ID,
          vendaId: venda.SEQUENCIA
        })
        await this.atualizarListas()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.isLoading = false
      }
    },
    isVendaEntregue (venda) {
      return String((venda && venda.OP_RETORNO_ENTREGA) || '0').trim() === '1'
    },
    temOcorrenciaEntrega (venda) {
      return !!String((venda && venda.OBS_RETORNO) || '').trim()
    },
    statusEntregaVenda (venda) {
      if (this.isVendaEntregue(venda)) return 'ENTREGUE'
      if (this.temOcorrenciaEntrega(venda)) return 'OCORRENCIA'
      return 'PENDENTE'
    },
    variantEntregaVenda (venda) {
      if (this.isVendaEntregue(venda)) return 'success'
      if (this.temOcorrenciaEntrega(venda)) return 'warning'
      return 'secondary'
    },
    podeConfirmarEntregaVenda (venda) {
      return this.entregaLiberada && venda && !this.isVendaEntregue(venda)
    },
    async confirmarEntregaVenda (venda) {
      const confirm = await this.$bvModal.msgBoxConfirm(`Confirmar entrega da venda ${venda.N_VENDA || venda.SEQUENCIA}?`, {
        title: 'Confirmar Entrega',
        okTitle: 'SIM, CONFIRMAR',
        cancelTitle: 'CANCELAR',
        okVariant: 'success',
        centered: true
      })
      if (!confirm) return

      this.isLoading = true
      try {
        await this.$http.post('/api/protected/ordementrega/confirmarEntregaVenda', {
          ordemEntregaId: this.registro.ID,
          vendaId: venda.SEQUENCIA,
          usuario: window.localStorage.getItem('login')
        })
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Entrega confirmada com sucesso!')
        await this.atualizarListas()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.isLoading = false
      }
    },
    abrirOcorrenciaEntrega (venda) {
      this.ocorrenciaEntrega = {
        venda,
        tipo: null,
        observacao: venda.OBS_RETORNO || ''
      }
      this.$bvModal.show('modal-ocorrencia-entrega')
    },
    async salvarOcorrenciaEntrega () {
      if (!this.ocorrenciaEntrega.venda) return

      this.isLoading = true
      try {
        await this.$http.post('/api/protected/ordementrega/registrarOcorrenciaVenda', {
          ordemEntregaId: this.registro.ID,
          vendaId: this.ocorrenciaEntrega.venda.SEQUENCIA,
          tipoOcorrencia: this.ocorrenciaEntrega.tipo,
          observacao: this.ocorrenciaEntrega.observacao,
          usuario: window.localStorage.getItem('login')
        })
        this.$bvModal.hide('modal-ocorrencia-entrega')
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Ocorrencia registrada com sucesso!')
        await this.atualizarListas()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.isLoading = false
      }
    },
    async finalizarEntrega () {
      if (!this.registro.ID) return

      const semOcorrencia = this.vendasDaOrdem.filter(venda => !this.isVendaEntregue(venda) && !this.temOcorrenciaEntrega(venda))
      if (semOcorrencia.length) {
        const pedidos = semOcorrencia.map(venda => venda.N_VENDA || venda.SEQUENCIA).join(', ')
        await this.$bvModal.msgBoxOk(`Existem pedidos nao entregues sem ocorrencia: ${pedidos}`, {
          title: 'Pendencias de Entrega',
          okTitle: 'OK',
          okVariant: 'warning',
          centered: true
        })
        return
      }

      const pendentesComOcorrencia = this.vendasDaOrdem.filter(venda => !this.isVendaEntregue(venda) && this.temOcorrenciaEntrega(venda))
      const mensagem = pendentesComOcorrencia.length
        ? `Existem ${pendentesComOcorrencia.length} pedido(s) nao entregue(s) com ocorrencia registrada. Deseja finalizar a entrega mesmo assim?`
        : 'Deseja finalizar esta Ordem de Entrega?'

      const confirm = await this.$bvModal.msgBoxConfirm(mensagem, {
        title: 'Finalizar Entrega',
        okTitle: 'SIM, FINALIZAR',
        cancelTitle: 'CANCELAR',
        okVariant: 'success',
        centered: true
      })
      if (!confirm) return

      this.isLoading = true
      try {
        await this.$http.post('/api/protected/ordementrega/finalizarEntrega', {
          id: this.registro.ID,
          usuario: window.localStorage.getItem('login')
        })
        this.registro.STATUS = '4'
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Entrega finalizada com sucesso!')
        await this.atualizarListas()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.isLoading = false
      }
    },
    async liberar () {
      if (!this.registro.COD_MOTORISTA) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'O campo Motorista é obrigatório.')
        return
      }
      if (!this.registro.VEICULO_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'O campo Veículo/Caminhão é obrigatório.')
        return
      }

      const confirm = await this.$bvModal.msgBoxConfirm('Deseja liberar esta Ordem de Entrega?', {
        title: 'Liberar Ordem',
        okTitle: 'SIM, LIBERAR',
        cancelTitle: 'CANCELAR',
        okVariant: 'success',
        centered: true
      })
      if (!confirm) return

      this.isLoading = true
      try {
        await this.$http.post('/api/protected/ordementrega/liberar', {
          id: this.registro.ID,
          ordemEntrega: this.registro,
          usuario: window.localStorage.getItem('login')
        })
        this.registro.STATUS = '2'
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Ordem de Entrega liberada com sucesso!')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.isLoading = false
      }
    },
    async reabrir () {
      this.isLoading = true
      try {
        await this.$http.post(`/api/protected/ordementrega/reabrir/${this.registro.ID}`)
        this.registro.STATUS = '1'
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Ordem de Entrega reaberta com sucesso!')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.isLoading = false
      }
    },
    voltar () {
      this.$router.push('/expedicao/ordementrega/listagem')
    },
    async imprimirTotalizados () {
      if (!this.registro.ID || !this.totalizadosAgrupados.length) return

      const tiposMap = {
        produto:   'Produto',
        bairro:    'Bairro',
        municipio: 'Município',
        cliente:   'Cliente',
        vendedor:  'Vendedor'
      }

      const tipoAgrupamento = tiposMap[this.totalizados.agrupamento] || 'Produto'

      const veiculo = this.veiculoSelecionado
        ? (this.veiculoSelecionado.DESCRICAO || this.veiculoSelecionado.NOME || this.veiculoSelecionado.MODELO || '')
        : ''

      imprimirRelatorioEntrega({
        ordemId:         this.registro.ID,
        data:            this.registro.DATA,
        motorista:       this.registro.NOME_MOTORISTA || this.registro.COD_MOTORISTA || '',
        veiculo,
        placa:           this.registro.PLACA || '',
        observacao:      this.registro.OBSERVACAO || '',
        tipoAgrupamento,
        dadosAgrupados:  this.totalizadosAgrupados,
        dadosDetalhados: this.totalizados.dados,
        totalGeral:      this.totalGeral
      })
    },
    toggleDetalhesTotalizados (row) {
      if (this.totalizados.agrupamento === 'produto') return

      if (row.detailsShowing) {
        row.toggleDetails()
        return
      }

      const agrupamento = this.totalizados.agrupamento
      const campoFiltro = {
        cliente: 'COD_CLI',
        vendedor: 'COD_VENDEDOR',
        municipio: 'MUNICIPIO_ID',
        bairro: 'BAIRRO'
      }[agrupamento]

      const produtosMap = {}
      this.totalizados.dados.forEach(item => {
        if (String(item[campoFiltro] ?? '') !== String(row.item.CODIGO ?? '')) return
        const codPro = item.COD_PRO
        if (!produtosMap[codPro]) {
          produtosMap[codPro] = {
            COD_PRO: item.COD_PRO,
            NOME_PRODUTO: item.NOME_PRODUTO,
            QUANT: 0,
            PECAS: 0,
            PECAS_PEDIDO: 0
          }
        }
        produtosMap[codPro].QUANT        += Number(item.QUANT        || 0)
        produtosMap[codPro].PECAS        += Number(item.PECAS        || 0)
        produtosMap[codPro].PECAS_PEDIDO += Number(item.PECAS_PEDIDO || 0)
      })

      this.$set(row.item, 'detalhes', Object.values(produtosMap))
      row.toggleDetails()
    },
    traduzStatus (status) {
      if (status === '0') return 'CANCELADA'
      if (status === '1') return 'ABERTA'
      if (status === '2') return 'LIBERADA'
      if (status === '4') return 'FINALIZADA'
      return 'INDEF'
    },
    formatarData (valor) {
      return valor ? moment(String(valor)).format('DD/MM/YYYY') : ''
    },
    formatarQuant (valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
    }
  }
}
</script>

<style scoped>
.load-capacity-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease;
}

.load-capacity-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08) !important;
}

.load-icon-box {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.load-icon-box.green-theme {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.load-icon-box.orange-theme {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

.load-icon-box.red-theme {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}

.custom-progress-container {
  height: 10px;
  background-color: #e9ecef;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

.custom-progress-bar-fill {
  height: 100%;
  border-radius: 5px;
  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.bg-gradient-success {
  background: linear-gradient(90deg, #28a745, #34ce57);
}

.bg-gradient-warning {
  background: linear-gradient(90deg, #ffc107, #ffdb70);
}

.bg-gradient-danger {
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
}

.tracking-wider {
  letter-spacing: 0.05em;
}

.uppercase {
  text-transform: uppercase;
}

.border-md-left {
  border-left: 1px solid #e9ecef;
}

.border-md-right {
  border-right: 1px solid #e9ecef;
}

@media (max-width: 767.98px) {
  .border-md-left,
  .border-md-right {
    border-left: none !important;
    border-right: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/expedicao/ordementrega/OrdemEntregaCadastro.vue